$ = require('jquery')

AccordionStateHolder = ($timeout) ->
  steps: [
    id: 'step-select-club'
    isOpen: true
  ,
    id: 'step-round-info'
    isOpen: false
  ,
    id: 'step-select-players'
    isOpen: false
  ,
    id: 'step-score-enter'
    isOpen: false
  ]
  editMode: false

  init: (round) ->
    if round
      @steps[0].isOpen = false
      @steps[1].isOpen = true
      @steps[2].isOpen = true
      @steps[3].isOpen = true
      @editMode = true
    else
      @steps[0].isOpen = true
      @steps[1].isOpen = false
      @steps[2].isOpen = false
      @steps[3].isOpen = false
      @editMode = false

  goToStep: (stepIndex) ->
    step = @steps[stepIndex]
    step.isOpen = true
    $element = $('#' + step.id)
    $timeout ->
      $('html, body').animate
        scrollTop: $element.offset().top
      , 200
      $element.find('input:enabled').first().focus()
    , 200

AccordionStateHolder.$inject = ['$timeout']

module.exports = AccordionStateHolder



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/accordion-state-holder-service.coffee